import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'
import fetchAPI from '../../common/fetchAPI'
import { AccountClientStateClass } from './interfaces/AccountClientStateClass'
import { formatNumberCustomoriginalapiforclient } from '../../common/timeLiveFunction';

const initialState: AccountClientStateClass = {
    isLoading: false,
    status: 'idle',
    accountClientList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    start: 0,
    search: "",
    recordsFiltered: 0,
    columnIndex: 0,
    direction: "asc",
    tab: "Basic",
    sortOrder: 'asc',
    sortColumn: '3',
    filterClientName: "",
    filterClientNick: "",
    filterEmailAddress: "",
    filterCountryId: 0,
    filterStatus: -1,
}

interface IThunkApi {
    state: {
        accountClient: AccountClientStateClass;
    },
}

export const getClientDatatableAsync = createAsyncThunk<any, any, IThunkApi>(
    'accountClient/getClientDatatable',
    async (arg, thunkApi) => {
        const { 
            currentPage, pageSize, start, order,  orderDir,search, ClientName,ClientNick,EmailAddress,CountryId,IsDisabled} = arg;

        const { sortColumn, sortOrder } = thunkApi.getState().accountClient;
        const cName = ClientName || "";
        const cNick = ClientNick || "";
        const email = EmailAddress || "";
        const country = CountryId ?? 0;
        const status = IsDisabled ?? -1;         
        const url = `api/V2/Clients/ClientDatatable/${currentPage}/${pageSize}/${start}?Order=${sortColumn}&OrderDir=${sortOrder}&search=${search}&ClientName=${cName}&ClientNick=${cNick}&EmailAddress=${email}&CountryId=${country}&IsDisabled=${status}`;     
        const response = await fetchAPI(url, 'Get', '', true, '');            
        const json = await response.json();
        return json;
    }
);
export const getClientDataByIAsync = createAsyncThunk<any, any, IThunkApi>(
  'accountClient/getClientDataById',
  async (arg, thunkApi) => {
    const { AccountClientId, decimalPlaces, cultureInfoName } = arg;

    console.log("AccountClientId:", AccountClientId);

    const response = await fetchAPI(
      `api/V2/Clients/${AccountClientId}`,   // <-- template literal fixed
      'Get',
      '',
      true,
      'a73f036e-6d84-440b-85e0-70e157c5eef7'
    );

    const json = await response.json();
    return json;
  }
);


export const addClientsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountClient/addClients',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Clients/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const updateClientsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountClient/updateClientsAsync',
        async (arg, thunkApi) => {
            const { AccountPartyId, AccountClientId, ...argWithoutId } = arg;
            const Id = !AccountPartyId ? AccountClientId : AccountPartyId;
            const response = await fetchAPI('api/V2/Clients/' + Id, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const updateIsDisabledAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountClient/updateIsDisabledAsync',
        async (arg, thunkApi) => {
            const { AccountPartyId, AccountClientId, ssnnoo, Country, ...argWithoutId } = arg;
            const Id = !AccountPartyId ? AccountClientId : AccountPartyId;
            const response = await fetchAPI('api/V2/Clients/' + Id, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteClientAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'accountClient/deleteClient',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Clients/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAllSelectedClientAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "accountClient/deleteAllSelectedClient",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Clients/deleteAllSelectedClient/', 'DELETE', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;

        }
    )

export const accountClientSlice = createSlice({
    name: 'accountClient',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.accountClientList.findIndex((item) => item.AccountClientId == action.payload);
            const newArray = [...state.accountClientList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.accountClientList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.accountClientList.findIndex((item) => item.AccountClientId == action.payload);
            const newArray = [...state.accountClientList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.accountClientList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.accountClientList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.accountClientList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.accountClientList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.accountClientList = newArray;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
        },
        setSortConfig: (state, action) => {
            const { columnIndex, direction } = action.payload;
            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';
            }
            state.direction = ndirection;
            state.columnIndex = columnIndex;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSearchValue: (state, action) => {
            state.search = action.payload;
           // state.currentPage = 1;
        },
        setClientActiveTab: (state, action) => {
            state.tab = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.start = action.payload.start;
            state.pageSize = action.payload.pageSize;
            state.currentPage = action.payload.currentPage;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.search = action.payload;
        },
        setFilters: (state, action) => {
            state.filterClientName = action.payload.ClientName;
            state.filterClientNick = action.payload.ClientNick;
            state.filterEmailAddress = action.payload.EmailAddress;
            state.filterCountryId = action.payload.CountryId;
            state.filterStatus = action.payload.IsDisabled;
            state.currentPage = 1;
        },
        resetFiltersState: (state) => {
            state.filterClientName = "";
            state.filterClientNick = "";
            state.filterEmailAddress = "";
            state.filterCountryId = 0;
            state.filterStatus = -1;
            state.currentPage = 1;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getClientDatatableAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getClientDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.accountClientList = JSON.parse(payload.Data.data);
                state.accountClientList.map((item: any) => {
                    item.isSelected = 0
                });
                state.totalItems = payload.Data.recordsTotal;
                state.recordsFiltered = payload.Data.recordsFiltered;
                state.currentPage = payload.Data.currentPage;
                state.start = payload.Data.start;
                state.search = payload.Data.search;
                state.isReload = false;
                state.isLoading = false;
                //state.selectedRecord = {};
                
            })
            .addCase(getClientDatatableAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getClientDataByIAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getClientDataByIAsync.fulfilled, (state, action) => {

                state.status = 'idle';
                

    const decimalPlaces = action.meta.arg.decimalPlaces;

    const payload = action.payload;
    const clientData = payload.Data[0];
    const culture = action.meta.arg.cultureInfoName;

        let formattedRate = '';
        let formattedFixedCost = '';

            if (clientData.DefaultBillingRate !== null && clientData.DefaultBillingRate !== undefined) {
                        formattedRate = Number(clientData.DefaultBillingRate).toFixed(decimalPlaces);
            }
            if (clientData.FixedCost !== null && clientData.FixedCost !== undefined) {
                        formattedFixedCost = Number(clientData.FixedCost).toFixed(decimalPlaces);
            }
           //const result = formatNumberCustomoriginalapiforclient(culture, formattedRate, decimalPlaces)
           //console.log(result,"resultttt")
    //             const isCommaSeparator = determineCommaSeprater(culture);

    // if (isCommaSeparator) {
    //     formattedRate = formattedRate.replace('.', ','); // Spanish: 6.50 → 6,50
    //     formattedFixedCost = formattedFixedCost.replace('.', ','); // Spanish: 6.50 → 6,50
    // } else if (isCommaSeparator === false) {
    //     formattedRate = formattedRate.replace(',', '.'); // US: 6,50 → 6.50
    //     formattedFixedCost = formattedFixedCost.replace(',', '.'); // US: 6,50 → 6.50
    // }
    state.selectedRecord = {
        ...clientData,
        DefaultBillingRate: formatNumberCustomoriginalapiforclient(culture, formattedRate, decimalPlaces),//formattedRate,
        FixedCost: formatNumberCustomoriginalapiforclient(culture, formattedFixedCost, decimalPlaces),
    };
            //}
    //let formattedRate = clientData.DefaultBillingRate?.toString() || '';




/*     state.selectedRecord = {
        ...clientData,
        DefaultBillingRate: formatNumberCustom(
            culture,
            clientData.DefaultBillingRate,
            decimalPlaces
        ), 

    }; */

                state.isLoading = false;
            })
            .addCase(getClientDataByIAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(addClientsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addClientsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addClientsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateClientsAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateClientsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = state.isReload ? false : true;
                if (payload.StatusCode === "200") {
                    localStorage.setItem('objClient', JSON.stringify({ AccountClientId: payload.Data[0].AccountClientId, AccountClientName: payload.Data[0].ClientName }));
                }
            })
            .addCase(updateClientsAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateIsDisabledAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateIsDisabledAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(updateIsDisabledAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteClientAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteClientAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.isReload = true;
            })
            .addCase(deleteClientAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedClientAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAllSelectedClientAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAllSelectedClientAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})
export const {
    resetSelectedRecordObjectInState,
    checkedState,
    unCheckedState,
    checkedAllState,
    unCheckedAllState,
    checkAllCheckboxIsUncheckedState,
    setPageSize,
    setSortConfig,
    setSearchValue,
    setClientActiveTab,
    updateSorting,
    updateSearchPagination,
    setFilters,resetFiltersState
} = accountClientSlice.actions
export const accountClientStateClass = (state: RootState) => state.accountClient
export default accountClientSlice.reducer